import { useRef, useEffect, EffectCallback, DependencyList } from 'react';

/**
 * This hook is an analog of life-circle method "componentDidUpdate".
 * Use it if you need to skip first render and run effect on component update only.
 */
export function useDidUpdateEffect(effect: EffectCallback, deps?: DependencyList) {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      effect();
    } else {
      didMountRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
